import { render } from "./FoundersAddInputApp.vue?vue&type=template&id=26bcf398&scoped=true"
import script from "./FoundersAddInputApp.vue?vue&type=script&lang=js"
export * from "./FoundersAddInputApp.vue?vue&type=script&lang=js"

import "./FoundersAddInputApp.vue?vue&type=style&index=0&id=26bcf398&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26bcf398"]])

export default __exports__